// this module is depricated. TBD - move SupplierQuality app from this api to comments.comments

import { make } from 'vuex-pathify'
import rpc from '../../api/rpc'

const state = {
  comments: null
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  async commentsFetch ({ commit }, params) {
    commit('SET_COMMENTS', null)
    const response = await rpc('comments.comments_fetch', params)
    if (response) {
      commit('SET_COMMENTS', response)
      return true
    }
  },
  async commentsDelete ({ commit }, id) {
    const response = await rpc('comments.comments_delete', id)
    if (response && response.result === 'Success') {
      const newState = JSON.parse(JSON.stringify(state.comments)).filter(r => r.id !== id)
      commit('SET_COMMENTS', newState)
      return true
    }
  },
  async commentsCreate ({ commit, state }, params) {
    const response = await rpc('comments.comments_create', params)
    const newComment = { ...params, id: null }
    if (response && response.result === 'Success') {
      newComment.id = response.new_id
      const newState = JSON.parse(JSON.stringify(state.comments)) || []
      newState.push(newComment)
      commit('SET_COMMENTS', newState)
      return true
    }
  }
}

export default { state, actions, mutations, namespaced }
